module.exports = __webpack_public_path__ + "img/worldOfMusicLogo.13612b34.png";